<template>
  <div class="whatsapp-cta">
    <div class="secondary--text font-weight-light text-h5 mb-7">
      <span class="Dm-display">Solicite uma análise ou entre em contato</span>
    </div>

    <p class="grey--text text--darken-1 text-body-1 mb-8">
      Fale diretamente com nossa equipe pelo WhatsApp e receba orientação
      personalizada sobre registro de marcas e patentes.
    </p>

    <v-btn
      :href="link"
      target="_blank"
      class="white--text text-none text-body-2 font-weight-bold rounded-0"
      depressed
      color="#25D366"
      height="52px"
      width="100%"
    >
      <v-icon left>fab fa-whatsapp</v-icon>
      Falar pelo WhatsApp
    </v-btn>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

export default {
  props: {
    tel: {
      type: String,
      required: true,
    },
  },
  computed: {
    link() {
      return getWhatsappLinkFromPhone(this.tel);
    },
  },
};
</script>
